import React from "react";
import Preloader from "../helper/Preloader";

import HeaderThree from "../components/HeaderThree";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Account from "../components/Account";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import NewsletterTwo from "../components/NewsletterTwo";


const AccountPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="var(--brand-primary)" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderThree */}
      <HeaderThree />

      {/* Breadcrumb */}
      <Breadcrumb title={"Account"} />

      {/* Account */}
      <Account />

      {/* NewsletterTwo */}
      <NewsletterTwo />

      {/* Footer */}
      <Footer />

    </>
  );
};

export default AccountPage;